import { framework } from "@sablier/v2-contracts";
import { _ } from "@sablier/v2-mixins";
import { zeroAddress } from "viem";
import type { ABI, Output } from "@sablier/v2-contracts";
import type { IAddress, IWagmiAddress } from "@sablier/v2-types";
import type { ExtractAbiFunctionNames } from "abitype";

interface Params {
  chainId?: number;
  expected?: IAddress | undefined;
  name: ExtractAbiFunctionNames<ABI<"plugin">>;
  proxy: string;
  registry: IAddress;
}

export default class Plugin {
  static async isValid({
    expected,
    value,
  }: {
    expected?: Params["expected"];
    value: IAddress | undefined;
  }) {
    if (_.isNilOrEmptyString(value)) {
      return false;
    }

    if (_.toAddress(value) === _.toAddress(zeroAddress)) {
      return false;
    }

    if (
      !_.isNilOrEmptyString(expected) &&
      _.toAddress(value) !== _.toAddress(expected)
    ) {
      return false;
    }

    return true;
  }

  static async isInstalled({
    chainId,
    expected,
    name,
    proxy,
    registry,
  }: Params) {
    const selector = await framework.selector("plugin", name);

    const query = framework.contextualize(
      registry,
      chainId!,
      "registry",
      "getPluginByProxy",
      [proxy! as IWagmiAddress, selector],
    );

    const previews = await framework.preview({ queries: [query] });
    const results = await framework.read(previews);

    const value = results[0].result as Output<"registry", "getPluginByProxy">;

    return Plugin.isValid({ expected, value });
  }
}
